import * as styles from './SelectControlErrorText.module.css'

function SelectControlErrorText({
  className = styles.SelectControlErrorText,
  text,
  ...restProps
}) {
  return (
    <div {...restProps} className={className}>
      {text}
    </div>
  )
}

export default SelectControlErrorText
